<!-- Animate if window is open -->
<div class="ticket-transfer-select-bar" *ngIf="isOpen$ | async" @slideUpAnimation>
  <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1" />
  <div class="container">
    <div class="action-wrapper">
      <div class="tickets-selected">
        {{ 'fgbcl.ticket.transfer.select.bar.selected' | translate: { count: selectedTickets$ | async } }}
      </div>
      <button class="btn ticket-transfer-btn" [routerLink]="['transfer']">
        {{ 'fgbcl.ticket.transfer.select.bar.button' | translate }}
      </button>
    </div>
  </div>
</div>
